// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"e2353907","91":"af2b9eb8","216":"3249ecd4","255":"4ee60e4f","453":"6a55f750","549":"bc98e259","696":"acee2176","707":"db2a405d","720":"ca388c70","785":"51ace432","787":"04abd8d5","816":"8492d460","866":"cfd30151","956":"f9149955","977":"41d3868c","979":"024b6c56"}[chunkId] + ".chunk.js";
};